<template>
	<ui-dialog
		ref="dialog"
		class="web-player-dialog"
		closable
		large
		@open="play"
	>
		<template slot="header">
			<h6 class="ui-title">{{ mediaData.comment || mediaData.title }}<div class="ui-caption">{{ mediaData.created | date }}</div></h6>
		</template>
		<WebPlayer
			ref="webPlayer"
		/>
	</ui-dialog>
</template>

<script>
import UiDialog from "lib/components/ui/Dialog";
import WebPlayer from "lib/components/WebPlayer";

export default {
	name: "WebPlayerDialog",
	components: {
		UiDialog,
		WebPlayer
	},
	data() {
		return {
			mediaData: {}
		};
	},
	mounted() {
		this.playMedia = (mediaData, recorderApiUrl) => {
			this.mediaData = mediaData;
			this.recorderApiUrl = recorderApiUrl;
			this.$refs.dialog.open();
		};
	},
	methods: {
		switchToEditor() {
			this.$refs.webPlayer.player.pause();
			this.$emit("trimMedia", this.mediaData, this.recorderApiUrl, this.$refs.webPlayer.player.getPosition());
			this.$refs.dialog.close();
		},
		play() {
			this.$refs.webPlayer.setup({
				file: `${this.recorderApiUrl}/media?secid=${encodeURIComponent(this.mediaData.secid)}&type=video`,
				type: "mp4"
			});

			if (this.mediaData.duration === 0)
				return;

			this.$refs.webPlayer.player.addButton(
				// using SVG from Font Awesome fa-cut icon (https://fontawesome.com/icons/cut?style=solid)
				"<svg xmlns=\"http://www.w3.org/2000/svg\" class=\"jw-svg-icon jw-svg-icon-trim\" viewBox=\"0 0 448 512\"><path d=\"M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z\"></path></svg>",
				"Trim video",
				() => this.switchToEditor(),
				"trim",
				"jw-icon-trim"
			);
		}
	}
};
</script>

<style scoped>
.ui-title {
	margin-top: 0;
}
</style>
